/**
 * MultiSelect chips style Stripe — tableau de boutons "Tous" + options.
 * Actif = fond accent Stripe (`bg-stripe-accent text-white`), inactif =
 * fond blanc avec bordure. Premier bouton "Tous" se sélectionne
 * automatiquement quand `selected.length === 0`.
 */
export interface MultiSelectProps {
  options: ReadonlyArray<string>;
  selected: string[];
  onChange: (next: string[]) => void;
}

export function MultiSelect({ options, selected, onChange }: MultiSelectProps) {
  const allSelected = selected.length === 0;

  function toggle(value: string): void {
    if (selected.includes(value)) {
      onChange(selected.filter((v) => v !== value));
    } else {
      onChange([...selected, value]);
    }
  }

  const baseClasses = 'px-2.5 py-[5px] rounded-md text-2xs font-medium transition-colors';

  return (
    <div className="flex max-h-32 flex-wrap gap-1.5 overflow-y-auto">
      <button
        type="button"
        onClick={() => onChange([])}
        className={`${baseClasses} ${
          allSelected
            ? 'bg-stripe-accent text-white'
            : 'border border-stripe-border bg-white text-stripe-text-secondary hover:bg-stripe-hover'
        }`}
      >
        Tous
      </button>
      {options.map((opt) => {
        const isActive = selected.includes(opt);
        return (
          <button
            key={opt}
            type="button"
            onClick={() => toggle(opt)}
            className={`${baseClasses} ${
              isActive
                ? 'bg-stripe-accent text-white'
                : 'border border-stripe-border bg-white text-stripe-text-secondary hover:bg-stripe-hover'
            }`}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}
